import PropTypes from 'prop-types';
import React from 'react';
import FindOntologyRelatedResourceDialog from '../../application-core/FindOntologyRelatedResourceDialog';

class FindRelatedLabelPassthroughDialog extends React.Component {

    render() {

        return (
            <FindOntologyRelatedResourceDialog
                {...this.props}
                displayType={true}
                mode={{
                    allowLangSelection: false,
                    linkedSearchType: ["http://www.w3.org/2004/02/skos/core#Concept", "http://www.w3.org/2008/05/skos-xl#Label"],
                    linkedSearchLabel: ["http://www.w3.org/2004/02/skos/core#prefLabel", "http://www.w3.org/2008/05/skos-xl#literalForm"],
                    searchType: ["http://www.w3.org/2004/02/skos/core#Concept", "http://www.w3.org/2008/05/skos-xl#Label"],
                    searchIn: "http://www.w3.org/2004/02/skos/core#inScheme",
                    searchLabel: ["http://www.w3.org/2004/02/skos/core#prefLabel", "http://www.w3.org/2008/05/skos-xl#literalForm"],
                }} />
        );
    }
}

FindRelatedLabelPassthroughDialog.propTypes = {
    component: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.object
    ])
};

export default FindRelatedLabelPassthroughDialog;